import JsBarcode from 'jsbarcode'
import { createCanvas } from 'canvas'

export const createCode39Barcode = (input: string, displayValue?: boolean): string => {
  const canvas = createCanvas(300, 200)
  JsBarcode(canvas, input, { format: 'CODE39', displayValue: displayValue })
  return canvas.toDataURL()
}
